import { useEffect, useState } from "react";
import { ITEMS_PER_PAGE } from "../../../app/constants";
import { useDispatch, useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { Link } from "react-router-dom";
import {
  PencilIcon,
  TrashIcon,
  ArrowUpIcon,
  ArrowDownIcon,
} from "@heroicons/react/24/outline";
import Pagination from "../../common/Pagination";
import {
  deleteUserAsync,
  fetchAllUsersAsync,
  selectTotalUsers,
  selectUsers,
  updateUserByAdminAsync,
} from "../../user/userSlice";

function UsersList() {
  const alert = useAlert();
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const users = useSelector(selectUsers);
  const totalUsers = useSelector(selectTotalUsers);
  const [editableUserId, setEditableUserId] = useState(-1);
  const [sort, setSort] = useState({});

  const handleEdit = (user) => {
    setEditableUserId(user.id);
  };

  const handleUserRole = (e, user) => {
    const updateduser = { ...user, role: e.target.value };
    dispatch(updateUserByAdminAsync(updateduser));
    setEditableUserId(-1);
    alert.success("User Role Updated Successfully");
  };
  const handlePage = (page) => {
    setPage(page);
  };

  const handleSort = (sortOption) => {
    const sort = { _sort: sortOption.sort, _order: sortOption.order };
    console.log({ sort });
    setSort(sort);
  };

  const chooseColor = (status) => {
    switch (status) {
      case "user":
        return "bg-purple-200 text-purple-600";
      case "admin":
        return "bg-green-200 text-green-600";
      default:
        return "bg-purple-200 text-purple-600";
    }
  };

  const handleDeleteUser = (id) => {
    dispatch(deleteUserAsync(id));
    alert.success("Product Deleted Successfully");
  };

  useEffect(() => {
    const pagination = { _page: page, _limit: ITEMS_PER_PAGE };
    dispatch(fetchAllUsersAsync({ sort, pagination }));
  }, [dispatch, page, sort]);

  return (
    <>
      <div>
        <Link
          to="/admin/userform"
          className="rounded-md mx-2 my-6 bg-green-700 px-3 py-3 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Add New User
        </Link>
      </div>
      <div className="overflow-x-auto">
        <div className="bg-gray-100 flex items-center justify-center font-sans overflow-hidden">
          <div className="w-full">
            <div className="bg-white shadow-md rounded my-6">
              <table className="w-full table-auto">
                <thead>
                  <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
                    <th
                      className="py-3 px-2 text-left cursor-pointer pl-5"
                      onClick={(e) =>
                        handleSort({
                          sort: "id",
                          order: sort?._order === "asc" ? "desc" : "asc",
                        })
                      }
                    >
                      User Id{" "}
                      {sort._sort === "id" &&
                        (sort._order === "asc" ? (
                          <ArrowUpIcon className="w-4 h-4 inline"></ArrowUpIcon>
                        ) : (
                          <ArrowDownIcon className="w-4 h-4 inline"></ArrowDownIcon>
                        ))}
                    </th>
                    <th className="py-3 px-2 text-center">Name</th>

                    <th className="py-3 px-2 text-center">Email</th>

                    <th className="py-3 px-2 text-center">Role</th>

                    <th className="py-3 px-2 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody className="text-gray-600 text-sm font-light">
                  {users &&
                    users.map((user) => (
                      <tr
                        key={user.id}
                        className="buser-b buser-gray-200 hover:bg-gray-100"
                      >
                        <td className="py-3 px-2 text-left whitespace-nowrap">
                          <div className="flex items-center">
                            <div className="mr-2"></div>
                            <span className="font-medium">{user.id}</span>
                          </div>
                        </td>
                        <td className="py-3 px-2 text-center">
                          <div className="flex items-center justify-center">
                            {user.name}
                          </div>
                        </td>
                        <td className="py-3 px-2 text-center">
                          <div className="flex items-center justify-center">
                            {user.email}
                          </div>
                        </td>
                        <td className="py-3 px-2 text-center">
                          {user.id === editableUserId ? (
                            <select
                              onChange={(e) => handleUserRole(e, user)}
                              value={user.role}
                            >
                              <option value="user">User</option>
                              <option value="admin">Admin</option>
                            </select>
                          ) : (
                            <span
                              className={`${chooseColor(
                                user.role
                              )} py-1 px-3 rounded-full text-xs`}
                            >
                              {user.role}
                            </span>
                          )}
                        </td>
                        <td className="py-3 px-2 text-center">
                          <div className="flex item-center justify-center">
                            <div className="w-6 mr-5 transform hover:text-purple-500 hover:scale-120">
                              <PencilIcon
                                className="w-8 h-8"
                                onClick={(e) => handleEdit(user)}
                              ></PencilIcon>
                            </div>
                            <div className="w-6 mr-4 transform hover:text-purple-500 hover:scale-120">
                              <TrashIcon
                                className="w-8 h-8"
                                onClick={(e) => handleDeleteUser(user.id)}
                              ></TrashIcon>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <Pagination
          page={page}
          setPage={setPage}
          handlePage={handlePage}
          totalItems={totalUsers}
        ></Pagination>
      </div>
    </>
  );
}

export default UsersList;
